import { channelCode } from "@/utils/channelCode";
import request from "./fetch";
getConfigData()
export async function getConfigData() {
  const res = await request({
    url: "/auth/get-wx-config",
    method: "POST",
    data: {
      url: location.href,
      appId: "wx5560a79be8783f5d",
    },
  });
  if (res.code === 200) {
    /* eslint-disable */
    // @ts-ignore
    wx.config({
      debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
      // appId: res.data.appId, // 必填，公众号的唯一标识
      appId: "wx5560a79be8783f5d", // 必填，公众号的唯一标识
      timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名
      jsApiList: [
        "chooseWXPay",
        "onMenuShareAppMessage" // 分享给朋友
      ], // 必填，需要使用的 JS 接口列表
    });
    // @ts-ignore
    wx.ready(function () {
     
      if (channelCode.value !== 'LD0008') {
        return
      }
      // 分享给朋友
      // @ts-ignore
      wx.onMenuShareAppMessage({
        title: '5283户外全球流量', // 分享标题
        desc: '全球数据流量卡', // 分享描述
        link: location.href, // 分享链接
        imgUrl: 'https://qyfw-international-card-h5.mobilecn.net/a0170a856ed9bd2f16de9c4073b20ef4.jpg', // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('分享给朋友成功');
        }
      });
    });
  }
}

export const getAuthUrl = async () => {
  const res = await request({
    url: `/auth/url`,
    method: "POST",
    data: {
      url: location.href.split("?")[0],
      // url: 'https://qyfw-international-card-h5.mobilecn.net',
      // url: 'test-bj-International-card-h5.liulv.net',
      appId: "wx5560a79be8783f5d",
    },
  });
  if (res.code === 200) {
    return {
      success: true,
      data: res.data,
    };
    location.replace(res.data);
  } else {
    return {
      success: false,
      data: res.message,
    };
  }
};

export const getUserInfo = async (code: string) => {
  const res = await request({
    url: `/auth/user_info`,
    method: "POST",
    data: {
      code: code,
      appId: "wx5560a79be8783f5d",
    },
  });
  if (res.code === 200) {
    return {
      success: true,
      data: res.data,
    };
  } else {
    return {
      success: false,
      data: res.message,
    };
  }
};